// Autogenerated locales - do not modify
/* tslint:disable quotemark variable-name */
export const SEARCH_IN_FORUM = "H\u013eadaj v diskusi\u00e1ch na kon\u00edku...";
export const SEARCH_RESULTS_FOR = "V\u00fdsledky vyh\u013ead\u00e1vania pre slovo";
